import { Color } from "@dotlegal/dotlegal-ui-components";
import { DotLegalSelectOption } from "@common/components/dotLegalMultiSelect/DotLegalMultiSelect.types.ts";
import { SelectableItem } from "../../../processingActivity/ProcessingActivity.types.ts";

export const activeLegalEntityStatusOptionId = "active";
// The id is persisted on entity templates, so it keeps its original spelling even though the label now reads
// "archived".
export const deactivatedLegalEntityStatusOptionId = "deactivated";

export const approvedLegalEntityOptionId = "approved";
export const notApprovedLegalEntityOptionId = "notApproved";

export function getLegalEntityTypeSelectOptions(legalEntityTypes: Array<SelectableItem>, unDeletableTypes: Array<string> = []): Array<DotLegalSelectOption> {
    return legalEntityTypes.map((legalEntityType) => {
        const unDeletable = unDeletableTypes.includes(legalEntityType.id);

        return {
            id: legalEntityType.id,
            name: legalEntityType.name,
            unDeletable: unDeletable,
            color: unDeletable ? Color.purple : undefined,
        };
    });
}

export function getLegalEntityStatusOptions(translateString: (key: string) => string): Array<DotLegalSelectOption> {
    return [
        { id: activeLegalEntityStatusOptionId, name: translateString("active") },
        { id: deactivatedLegalEntityStatusOptionId, name: translateString("archived") },
    ];
}

export function getLegalEntityApprovedOptions(translateString: (key: string) => string): Array<DotLegalSelectOption> {
    return [
        { id: approvedLegalEntityOptionId, name: translateString("yes") },
        { id: notApprovedLegalEntityOptionId, name: translateString("no") },
    ];
}
